export const archiveList = [require("./squeakland").default];



// WEBPACK FOOTER //
// ./src/archive/index.js